// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgePlpApi = class EdgePlpApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param ScriptsPlpAccountRegisterAccount default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountRegister(ScriptsPlpAccountRegisterAccount, x_program_id) {
        const _url_ = '/edge/plp/Account/register';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ScriptsPlpAccountRegisterAccount' is not null or undefined
        if (ScriptsPlpAccountRegisterAccount === null || ScriptsPlpAccountRegisterAccount === undefined) {
            throw new Error('Required parameter ScriptsPlpAccountRegisterAccount was null or undefined when calling accountRegister.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ScriptsPlpAccountRegisterAccount, "ScriptsPlpAccountRegisterAccount"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PlpAccountRegisterRegisterResponse");
        }
        return response;
    }
    /**
     *
     * @param ScriptsPlpClaimSumbitClaimRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async claimSubmitClaim(ScriptsPlpClaimSumbitClaimRequestModel, x_program_id) {
        const _url_ = '/edge/plp/Claim/submitClaim';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ScriptsPlpClaimSumbitClaimRequestModel' is not null or undefined
        if (ScriptsPlpClaimSumbitClaimRequestModel === null || ScriptsPlpClaimSumbitClaimRequestModel === undefined) {
            throw new Error('Required parameter ScriptsPlpClaimSumbitClaimRequestModel was null or undefined when calling claimSubmitClaim.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ScriptsPlpClaimSumbitClaimRequestModel, "ScriptsPlpClaimSumbitClaimRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ExtClaimSubmitClaimResultModelResponse");
        }
        return response;
    }
    /**
     *
     * @param ExtEnrollmentHybridEnrollmentRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async enrollPatientEnrollPatient(ExtEnrollmentHybridEnrollmentRequestModel, x_program_id) {
        const _url_ = '/edge/plp/Enrollment/enrollPatient';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ExtEnrollmentHybridEnrollmentRequestModel' is not null or undefined
        if (ExtEnrollmentHybridEnrollmentRequestModel === null || ExtEnrollmentHybridEnrollmentRequestModel === undefined) {
            throw new Error('Required parameter ExtEnrollmentHybridEnrollmentRequestModel was null or undefined when calling enrollPatientEnrollPatient.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ExtEnrollmentHybridEnrollmentRequestModel, "ExtEnrollmentHybridEnrollmentRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ExtEnrollmentHybridEnrollmentResultModelResponse");
        }
        return response;
    }
    /**
     *
     * @param ExtEnrollmentMedBenEnrollmentUpdateRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async enrollPatientEnrollmentUpdate(ExtEnrollmentMedBenEnrollmentUpdateRequestModel, x_program_id) {
        const _url_ = '/edge/plp/Enrollment/enrollmentUpdate';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ExtEnrollmentMedBenEnrollmentUpdateRequestModel' is not null or undefined
        if (ExtEnrollmentMedBenEnrollmentUpdateRequestModel === null || ExtEnrollmentMedBenEnrollmentUpdateRequestModel === undefined) {
            throw new Error('Required parameter ExtEnrollmentMedBenEnrollmentUpdateRequestModel was null or undefined when calling enrollPatientEnrollmentUpdate.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ExtEnrollmentMedBenEnrollmentUpdateRequestModel, "ExtEnrollmentMedBenEnrollmentUpdateRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ExtEnrollmentHybridEnrollmentResultModelResponse");
        }
        return response;
    }
    /**
     *
     * @param ExtEnrollmentHybridEnrollmentRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async enrollPatientExpressEnrollment(ExtEnrollmentHybridEnrollmentRequestModel, x_program_id) {
        const _url_ = '/edge/plp/Enrollment/expressEnrollment';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ExtEnrollmentHybridEnrollmentRequestModel' is not null or undefined
        if (ExtEnrollmentHybridEnrollmentRequestModel === null || ExtEnrollmentHybridEnrollmentRequestModel === undefined) {
            throw new Error('Required parameter ExtEnrollmentHybridEnrollmentRequestModel was null or undefined when calling enrollPatientExpressEnrollment.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ExtEnrollmentHybridEnrollmentRequestModel, "ExtEnrollmentHybridEnrollmentRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ExtEnrollmentHybridEnrollmentResultModelResponse");
        }
        return response;
    }
    /**
     *
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientGetEnrollments(x_program_id) {
        const _url_ = '/edge/plp/Patient/getEnrollments';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PlpPatientGetEnrollmentsGetEnrollmentsResponse");
        }
        return response;
    }
    /**
     *
     * @param PatientLookupRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientPatientLookup(PatientLookupRequestModel, x_program_id) {
        const _url_ = '/edge/plp/Patient/patientLookup';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PatientLookupRequestModel' is not null or undefined
        if (PatientLookupRequestModel === null || PatientLookupRequestModel === undefined) {
            throw new Error('Required parameter PatientLookupRequestModel was null or undefined when calling patientPatientLookup.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PatientLookupRequestModel, "PatientLookupRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PlpPatientPatientLookupPatientLookupResponse");
        }
        return response;
    }
    /**
     *
     * @param ExtEnrollmentPatientUpdateRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientUpdate(ExtEnrollmentPatientUpdateRequestModel, x_program_id) {
        const _url_ = '/edge/plp/Patient/update';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ExtEnrollmentPatientUpdateRequestModel' is not null or undefined
        if (ExtEnrollmentPatientUpdateRequestModel === null || ExtEnrollmentPatientUpdateRequestModel === undefined) {
            throw new Error('Required parameter ExtEnrollmentPatientUpdateRequestModel was null or undefined when calling patientUpdate.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ExtEnrollmentPatientUpdateRequestModel, "ExtEnrollmentPatientUpdateRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentResponseModel");
        }
        return response;
    }
    /**
     *
     * @param EnrollmentCreatePrescriberRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async prescriberCreatePrescriber(EnrollmentCreatePrescriberRequestModel, x_program_id) {
        const _url_ = '/edge/plp/Prescriber/createPrescriber';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'EnrollmentCreatePrescriberRequestModel' is not null or undefined
        if (EnrollmentCreatePrescriberRequestModel === null || EnrollmentCreatePrescriberRequestModel === undefined) {
            throw new Error('Required parameter EnrollmentCreatePrescriberRequestModel was null or undefined when calling prescriberCreatePrescriber.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(EnrollmentCreatePrescriberRequestModel, "EnrollmentCreatePrescriberRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentCreatePrescriberResultModelResponse");
        }
        return response;
    }
    /**
     *
     * @param EnrollmentCreateSiteRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteCreateSite(EnrollmentCreateSiteRequestModel, x_program_id) {
        const _url_ = '/edge/plp/Site/createSite';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'EnrollmentCreateSiteRequestModel' is not null or undefined
        if (EnrollmentCreateSiteRequestModel === null || EnrollmentCreateSiteRequestModel === undefined) {
            throw new Error('Required parameter EnrollmentCreateSiteRequestModel was null or undefined when calling siteCreateSite.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(EnrollmentCreateSiteRequestModel, "EnrollmentCreateSiteRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentCreateSiteResultModelResponse");
        }
        return response;
    }
};
EdgePlpApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgePlpApi);
export { EdgePlpApi };
//# sourceMappingURL=edgePlpApi.js.map